export enum FieldType {
  BOOL = 'Edm.Boolean',
  // Integer types
  BYTE = 'Edm.Byte',
  INT16 = 'Edm.Int16',
  INT32 = 'Edm.Int32',
  INT64 = 'Edm.Int64',
  // Decimal types
  DECIMAL = 'Edm.Decimal',
  DOUBLE = 'Edm.Double',
  SINGLE = 'Edm.Single',
  // Other common types for completeness
  STRING = 'Edm.String',
  DATE = 'Edm.Date',
  DATETIME = 'Edm.DateTime',
  GUID = 'Edm.Guid',
}

export const isDecimalType = (type: FieldType | string): boolean => {
  const decimalTypes = [FieldType.DECIMAL, FieldType.DOUBLE, FieldType.SINGLE];
  return decimalTypes.includes(type as FieldType);
};

export const isIntegerType = (type: FieldType | string): boolean => {
  const integerTypes = [
    FieldType.BYTE,
    FieldType.INT16,
    FieldType.INT32,
    FieldType.INT64,
  ];

  return integerTypes.includes(type as FieldType);
};

export const isNumericType = (type: FieldType | string): boolean => {
  return isIntegerType(type as FieldType) || isDecimalType(type as FieldType);
};
